export default __webpack_public_path__ + "static/media/34.0f0d9afb.png";